import { useNavigate, useSearchParams } from "react-router-dom";
import { LoginForm as BaseLoginForm } from "@racoon/ui";
import { LogoRaccoonAi } from "@racoon/icons";
import {
  useLoginMutation,
  useRequestOTPMutation,
  useLoginOTPMutation,
} from "~/shared/api/auth/auth.grpc";

export const LoginForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const defaultMode = searchParams.get("method") === "sms" ? "otp" : "password";

  const loginMutation = useLoginMutation();
  const requestOtpMutation = useRequestOTPMutation();
  const loginOtpMutation = useLoginOTPMutation();

  const handleSuccess = () => navigate("/");
  const handleForgotPassword = () => navigate("/forgot-password");

  return (
    <BaseLoginForm
      loginMutation={loginMutation as any}
      sendOtpMutation={requestOtpMutation as any}
      loginOtpMutation={loginOtpMutation as any}
      onSuccess={handleSuccess}
      onForgotPassword={handleForgotPassword}
      defaultMode={defaultMode}
      isGrpc={true}
      logo={<LogoRaccoonAi className="h-14 w-auto shrink-0 md:h-24" />}
    />
  );
};
